import React from "react";

function OddsStrip({ match, odds, nextMatch }) {

    if (!match) return null;

    return (
        <div className="odds-strip">
            <div className="odds-inner">
                <div className="odds-section-title">Match Result</div>
                <div className="odds-grid">
                    <div className="odds-block">
                        <div className="odds-block-title">Match Result (1X2)</div>
                        <div className="odds-row">
                            <div className="odds-cell">
                                <span className="odds-label">1 — {match.team1Name}</span>
                                <span className="odds-val">{odds ? odds.teamOneOdd.toFixed(2) : "—"}</span>
                            </div>
                            <div className="odds-cell">
                                <span className="odds-label dimmed">X — Draw</span>
                                <span className="odds-val neon">15.00</span>
                            </div>
                            <div className="odds-cell">
                                <span className="odds-label">2 — {match.team2Name}</span>
                                <span className="odds-val hot">{odds ? odds.teamTwoOdd.toFixed(2) : "—"}</span>
                            </div>
                        </div>
                    </div>

                    <div className="odds-block">
                        <div className="odds-block-title">Total Runs</div>
                        <div className="odds-row">
                            <div className="odds-cell">
                                <span className="odds-label">Over</span>
                                <span className="odds-val">—</span>
                            </div>
                            <div className="odds-cell">
                                <span className="odds-label">Under</span>
                                <span className="odds-val neon">—</span>
                            </div>
                        </div>
                    </div>

                    <div className="odds-block">
                        <div className="odds-block-title">
                            Next Match — #{nextMatch ? nextMatch.match.matchId : "—"}
                        </div>
                        <div className="odds-row">
                            <div className="odds-cell">
                                <span className="odds-label">{nextMatch ? nextMatch.match.team1Name : "—"}</span>
                                <span className="odds-val">{nextMatch ? nextMatch.odds.teamOneOdd.toFixed(2) : "—"}</span>
                            </div>
                            <div className="odds-cell">
                                <span className="odds-label dimmed">X — Draw</span>
                                <span className="odds-val neon">15.00</span>
                            </div>
                            <div className="odds-cell">
                                <span className="odds-label">{nextMatch ? nextMatch.match.team2Name : "—"}</span>
                                <span className="odds-val hot">{nextMatch ? nextMatch.odds.teamTwoOdd.toFixed(2) : "—"}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OddsStrip;
